module.exports = __webpack_public_path__ + "img/bg01.867759ad.jpg";